<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page back>
        <template
            slot="body"
        >
            <el-row>
                <el-col :span="24">
                    <el-form
                        ref="addForm"
                        size="small"
                        :model="formModel"
                        :rules="formRules"
                    >
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>店铺信息</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="orgId"
                                    label="组织机构"
                                    label-width="13em"
                                >
                                    <el-select
                                        v-model="formModel.orgId"
                                        placeholder="请选择"
                                        :disabled="formModel.id != null"
                                    >
                                        <el-option
                                            v-for="item in orgList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    prop="shopName"
                                    label="店铺名称"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.shopName"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="shopSn"
                                    label="店铺编码"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.shopSn"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="shopDomain"
                                    label="店铺域名"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.shopDomain"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="shopLevelId"
                                    label="店铺等级"
                                    label-width="13em"
                                >
                                    <el-select
                                        v-model="formModel.shopLevelId"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="item in shopLevelList"
                                            :key="item.id"
                                            :label="item.levelName"
                                            :value="item.id"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    prop="shopStatus"
                                    label="商户状态"
                                    label-width="13em"
                                >
                                    <dictionaries-picker
                                        type="shopStatus"
                                        v-model="formModel.shopStatus"
                                    />
                                </el-form-item>
                                <!--                    <el-form-item
            prop="joinTime"
            label="入驻时间"
            label-width="13em"
            >
            <el-date-picker
            v-model="formModel.joinTime"
            type="datetime"
            placeholder="选择入驻时间"
            />
            </el-form-item>-->
                                <el-form-item
                                    prop="shopLogo"
                                    label="店铺Logo"
                                    label-width="13em"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.shopLogo"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="shopShareLogo"
                                    label="店铺分享Logo"
                                    label-width="13em"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.shopShareLogo"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="loadingImg"
                                    label="加载图标"
                                    label-width="13em"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.loadingImg"
                                        tips="只能上传jpg/png/gif文件"
                                        accept="image/jpeg,image/gif,image/png"
                                    />
                                </el-form-item>
                                <!--                    <el-form-item
    prop="miniAppsImg"
    label="店铺小程序图标"
    label-width="13em"
    >
    <upload
    validate-md5
    action="/rs/attachment/uploadFileLibrary"
    :limit="1"
    v-model="formModel.miniAppsImg"
    />
    </el-form-item>-->
                                <el-form-item
                                    prop="themeColorMain"
                                    label="皮肤主颜色"
                                    label-width="13em"
                                >
                                    <el-color-picker v-model="formModel.themeColorMain"/>
                                </el-form-item>
                                <el-form-item
                                    prop="themeColorSecond"
                                    label="皮肤副颜色"
                                    label-width="13em"
                                >
                                    <el-color-picker v-model="formModel.themeColorSecond"/>
                                </el-form-item>
                                <el-form-item
                                    prop="currencySymbol"
                                    label="币种符号"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.currencySymbol"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="currencyCode"
                                    label="币种代码"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.currencyCode"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <!--                    <el-form-item
            prop="amountFormat"
            label="金额格式"
            label-width="13em"
            >
            <el-input
            v-model="formModel.amountFormat"
            auto-complete="off"
            />
            默认+0.00
            </el-form-item>-->
                                <!--                    <el-form-item
            prop="isQuickBuyerAddress"
            label="智能识别地址"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isQuickBuyerAddress"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="1"
            inactive-value="0"
            />
            </el-form-item>-->
                                <!--                    <el-form-item
            prop="isGoodsMultiStyle"
            label="商品素材多风格"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isGoodsMultiStyle"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="true"
            :inactive-value="false"
            />
            </el-form-item>-->
                                <!--                    <el-form-item
            prop="principalName"
            label="联系人姓名"
            label-width="13em"
            >
            <el-input
            v-model="formModel.principalName"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="principalPosition"
            label="联系人职务"
            label-width="13em"
            >
            <el-input
            v-model="formModel.principalPosition"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="principalMobile"
            label="联系人电话"
            label-width="13em"
            >
            <el-input
            v-model="formModel.principalMobile"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="principalEmail"
            label="联系人邮箱"
            label-width="13em"
            >
            <el-input
            v-model="formModel.principalEmail"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="principalQq"
            label="联系人QQ"
            label-width="13em"
            >
            <el-input
            v-model="formModel.principalQq"
            auto-complete="off"
            />
            </el-form-item>-->
                                <!--                    <el-form-item
            prop="shopRegionId"
            label="店铺地址"
            label-width="13em"
            >
            <CascaderPicker
            :api-class="selectApi"
            v-model="formModel.shopRegionId"
            :p-id="2"
            :min-lv="2"
            />
            </el-form-item>
            <el-form-item
            prop="shopAddress"
            label="详细地址"
            label-width="13em"
            >
            <el-input
            v-model="formModel.shopAddress"
            auto-complete="off"
            />
            </el-form-item>-->
                                <el-form-item
                                    prop="shopDesc"
                                    label="店铺描述"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.shopDesc"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <!--                    <el-form-item
            prop="freightMode"
            label="运费模式"
            label-width="13em"
            >
            <dictionaries-picker
            type="freightMode"
            v-model="formModel.freightMode"
            />
            </el-form-item>-->
                                <el-form-item
                                    prop="goodsCatStyle"
                                    label="商品分类样式"
                                    label-width="13em"
                                >
                                    <el-select
                                        v-model="formModel.goodsCatStyle"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            label="不启用"
                                            :value="99"
                                        />
                                        <el-option
                                            label="仅分类"
                                            :value="1"
                                        />
                                        <el-option
                                            label="分类+商品"
                                            :value="2"
                                        />
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    prop="isAllowMoreLevel"
                                    label="二级分类"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isAllowMoreLevel"
                                    />
                                    开启二级分类(备注：商品展示时默认只显示一级分类，如需显示二级分类则勾选此项）
                                </el-form-item>
                                <el-form-item
                                    prop="isShowNotice"
                                    label="是否显示公告"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isShowNotice"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="shopNoticeImage"
                                    prop="shopNoticeImage"
                                    label="公告图片"
                                    label-width="13em"
                                    v-if="formModel.isShowNotice"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.shopNoticeImage"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="shopNoticeLink"
                                    prop="shopNoticeLink"
                                    label="公告链接"
                                    label-width="13em"
                                    v-if="formModel.isShowNotice"
                                >
                                    <el-input
                                        v-model="formModel.shopNoticeLink"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="enableBehavior"
                                    label="是否开启用户行为监控"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.enableBehavior"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="remarks"
                                    label="备注"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.remarks"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>会员设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="isOpenMemberRegister"
                                    label="是否开放注册"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isOpenMemberRegister"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="memberRegisterMode"
                                    label="会员注册模式"
                                    label-width="13em"
                                >
                                    <checkbox-group-andOr
                                        type="memberRegisterMode"
                                        v-model="formModel.memberRegisterMode"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isCheckMobileFormat"
                                    label="是否校验手机号格式"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isCheckMobileFormat"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isCheckMobileCode"
                                    label="是否校验手机号验证码"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isCheckMobileCode"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="memberAccountSign"
                                    label="会员账号标识"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.memberAccountSign"
                                        auto-complete="off"
                                    />
                                    (4个字母以内)
                                </el-form-item>
                                <el-form-item
                                    prop="buyerConfig"
                                    label="会员功能"
                                    label-width="13em"
                                >
                                    <checkbox-group-andOr
                                        :data="[
                                            {id:1,name:'分销等级成长值'},
                                            {id:2,name:'会员等级成长值'},
                                            {id:4,name:'会员等级折扣'},
                                            {id:8,name:'会员积分'},
                                            {id:16,name:'分销等级折扣'},
                                            {id:32,name:'仅门店会员登录购买'},
                                        ]"
                                        v-model="formModel.buyerConfig"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="distributorRegisterMode"
                                    label="分销商注册模式"
                                    label-width="13em"
                                >
                                    <dictionaries-picker
                                        type="distributorRegisterMode"
                                        v-model="formModel.distributorRegisterMode"
                                    />
                                </el-form-item>
                                <!--                    <el-form-item
                                                        prop="isMustInvitationCode"
                                                        label="推荐码是否必填"
                                                        label-width="13em"
                                                    >
                                                        <template>
                                                            <el-radio
                                                                v-model="formModel.isMustInvitationCode"
                                                                :label="true"
                                                            >
                                                                是
                                                            </el-radio>
                                                            <el-radio
                                                                v-model="formModel.isMustInvitationCode"
                                                                :label="false"
                                                            >
                                                                否
                                                            </el-radio>
                                                        </template>
                                                    </el-form-item>
                                                    <el-form-item
                                                        prop="distributorQrcodeExpire"
                                                        label="分销商二维码有效期(天)"
                                                        label-width="13em"
                                                    >
                                                        <template>
                                                            <el-input-number
                                                                controls-position="right"
                                                                :min="0"
                                                                v-model.number="formModel.distributorQrcodeExpire"
                                                            />
                                                        </template>
                                                    </el-form-item>
                                                    <el-form-item
                                                        prop="isDistributorQrcodeUnique"
                                                        label="分销商二维码是否唯一"
                                                        label-width="13em"
                                                    >
                                                        <template>
                                                            <el-radio
                                                                v-model="formModel.isDistributorQrcodeUnique"
                                                                :label="true"
                                                            >
                                                                是
                                                            </el-radio>
                                                            <el-radio
                                                                v-model="formModel.isDistributorQrcodeUnique"
                                                                :label="false"
                                                            >
                                                                否
                                                            </el-radio>
                                                        </template>
                                                    </el-form-item>-->
                                <el-form-item
                                    prop="distributionIncomeMode"
                                    label="分销收益模式"
                                    label-width="13em"
                                >
                                    <checkbox-group-andOr
                                        type="distributionIncomeMode"
                                        v-model="formModel.distributionIncomeMode"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="defaultShareIncomeRate"
                                    prop="defaultShareIncomeRate"
                                    label="默认分享提成比例"
                                    label-width="13em"
                                    v-if="shareincome"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="2"
                                        v-model.number="formModel.defaultShareIncomeRate"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="distributionLevel"
                                    prop="distributionLevel"
                                    label="提成层级"
                                    label-width="13em"
                                    v-if="eachlevelincome"
                                >
                                    <dictionaries-picker
                                        type="distributionLevel"
                                        v-model="formModel.distributionLevel"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="eachLevelIncomeDayLimit"
                                    prop="eachLevelIncomeDayLimit"
                                    label="层级提成注册提成时间"
                                    label-width="13em"
                                    v-if="eachlevelincome"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="0"
                                        v-model.number="formModel.eachLevelIncomeDayLimit"
                                    />
                                    天（为0不限制）
                                </el-form-item>
                                <el-form-item
                                    prop="autoSettlementDay"
                                    label="分销自动结算天数"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="-1"
                                        :precision="0"
                                        v-model.number="formModel.autoSettlementDay"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="minWithdrawAmount"
                                    label="最低提现金额"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="2"
                                        v-model.number="formModel.minWithdrawAmount"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="withdrawPoundageRate"
                                    label="提现手续费（%）"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :max="100"
                                        :precision="2"
                                        v-model.number="formModel.withdrawPoundageRate"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="withdrawAutoPassTime"
                                    label="提现自动审核时间"
                                    label-width="13em"
                                >
                                    <el-time-select
                                        v-model="formModel.withdrawAutoPassTime"
                                        :picker-options="{
                                            start: '00:00',
                                            step: '00:30',
                                            end: '23:30'
                                        }"
                                        placeholder="选择时间">
                                    </el-time-select>
                                </el-form-item>
                                <el-form-item
                                    prop="withdrawDesc"
                                    label="提现描述"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.withdrawDesc"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>下单设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="isAllowOrder"
                                    label="是否允许下单"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isAllowOrder"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="orderAmountLimit"
                                    label="每日下单金额限制"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="2"
                                        v-model.number="formModel.orderAmountLimit"
                                    />(为0不限制)
                                </el-form-item>
                                <el-form-item
                                    prop="sellGoodsType"
                                    label="售卖商品类型"
                                    label-width="13em"
                                >
                                    <checkbox-group-andOr
                                        type="goodsType"
                                        v-model="formModel.sellGoodsType"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="goodsSendMode"
                                    label="商品发货方式"
                                    label-width="13em"
                                >
                                    <el-checkbox-group v-model="formModel.goodsSendMode">
                                        <el-checkbox label="1">
                                            国内现货
                                        </el-checkbox>
                                        <el-checkbox label="2">
                                            跨境直邮
                                        </el-checkbox>
                                        <el-checkbox label="3">
                                            BC直邮
                                        </el-checkbox>
                                        <el-checkbox label="4">
                                            保税区发货
                                        </el-checkbox>
                                        <el-checkbox label="5">
                                            一般贸易
                                        </el-checkbox>
                                        <el-checkbox label="6">
                                            社区配送
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item
                                    prop="goodsSendMode2OrderAmountLimit"
                                    label="跨境直邮多商品订单金额限制"
                                    label-width="13em"
                                    v-if="formModel.goodsSendMode.includes('2')"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="2"
                                        v-model.number="formModel.goodsSendMode2OrderAmountLimit"
                                    />(为0不限制)
                                </el-form-item>
                                <el-form-item
                                    prop="goodsSendMode4OrderAmountLimit"
                                    label="保税区发货多商品订单金额限制"
                                    label-width="13em"
                                    v-if="formModel.goodsSendMode.includes('4')"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="2"
                                        v-model.number="formModel.goodsSendMode4OrderAmountLimit"
                                    />(为0不限制)
                                </el-form-item>
                                <el-form-item
                                    prop="threeFactorCheck"
                                    label="姓名手机号身份证校验"
                                    label-width="13em"
                                >
                                    <el-checkbox-group v-model="formModel.threeFactorCheck">
                                        <el-checkbox label="2">
                                            跨境直邮
                                        </el-checkbox>
                                        <el-checkbox label="4">
                                            保税区发货
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item
                                    prop="shipMethod"
                                    label="配送方式"
                                    label-width="13em"
                                >
                                    <checkbox-group-andOr
                                        type="shipMethod"
                                        v-model="formModel.shipMethod"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="goodsConfig"
                                    label="商品功能"
                                    label-width="13em"
                                >
                                    <checkbox-group-andOr
                                        :data="[
                                            // {id:1,name:'商品保险'},
                                            {id:2,name:'商品预售'},
                                        ]"
                                        v-model="formModel.goodsConfig"
                                    />
                                </el-form-item>
                                <!--                    <el-form-item
            prop="paymentMode"
            label="订单付款模式"
            label-width="13em"
            >
            <checkbox-group-andOr
            type="paymentMode"
            v-model="formModel.paymentMode"
            />
            </el-form-item>-->
                                <el-form-item
                                    key="onlinePaymentType"
                                    prop="onlinePaymentType"
                                    label="订单付款类型"
                                    label-width="13em"
                                    v-if="onlinePayment"
                                >
                                    <checkbox-group-andOr
                                        :data="[
                                            {id:2,name:'微信支付'},
                                            {id:32,name:'支付宝支付'},
                                            {id:4096,name:'小程序支付'},
                                            {id:1024,name:'零钱支付'},
                                            {id:16384,name:'积分支付'},
                                            {id:32768,name:'airwallex支付'},
                                            {id:128,name:'富友支付'},
                                            {id:256,name:'全民支付'},
                                            {id:512,name:'paylinx支付'},
                                            {id:65536,name:'simplify支付'},
                                            {id:131072,name:'transferEasy支付'},
                                            {id:262144,name:'鲸汇支付'},
                                            {id:1048576,name:'omiPay'}
                                        ]"
                                        v-model="formModel.onlinePaymentType"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="balanceAlias"
                                    label="零钱别名"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.balanceAlias"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <!--                                 <el-form-item
                                                                    prop="prepaidPaymentMode"
                                                                    label="充值付款模式"
                                                                    label-width="13em"
                                                                >
                                                                    <checkbox-group-andOr
                                                                        type="paymentMode"
                                                                        v-model="formModel.prepaidPaymentMode"
                                                                    />
                                                                </el-form-item>-->
                                <!--                                <el-form-item
                                                                    key="prepaidPaymentType"
                                                                    prop="prepaidPaymentType"
                                                                    label="充值付款类型"
                                                                    label-width="13em"
                                                                    v-if="onlinePaymentBalance"
                                                                >
                                                                    <checkbox-group-andOr
                                                                        :data="[
                                                                            {id:2,name:'微信支付'},
                                                                            {id:4,name:'银联支付'},
                                                                            {id:8,name:'通联支付'},
                                                                            {id:16,name:'alphapay'},
                                                                            {id:32,name:'支付宝支付'},
                                                                            {id:64,name:'Stripe'},
                                                                            {id:128,name:'中投科信'},
                                                                            {id:256,name:'hantePay'},
                                                                            {id:512,name:'citconPay'},
                                                                            {id:4096,name:'小程序支付'},
                                                                        ]"
                                                                        v-model="formModel.prepaidPaymentType"
                                                                    />
                                                                </el-form-item>-->
                                <!--                    <el-form-item
            prop="orderNoticeMobile"
            label="下单提醒"
            label-width="13em"
            >
            <checkbox-group-andOr
            type="orderNoticeMode"
            v-model="formModel.orderNoticeMode"
            />
            </el-form-item>
            <el-form-item
            key="orderNoticeMobile"
            prop="orderNoticeMobile"
            label="提醒手机号"
            label-width="13em"
            v-if="orderNoticeMobile"
            >
            <el-input
            type="textarea"
            v-model="formModel.orderNoticeMobile"
            auto-complete="off"
            />
            多个手机号用|分隔
            </el-form-item>-->
                                <!--                                        <el-form-item
            prop="mapPlaceKey"
            label="地图接口key"
            label-width="13em"
            >
            <el-input
            v-model="formModel.mapPlaceKey"
            auto-complete="off"
            />
            </el-form-item>-->
                                <el-form-item
                                    key="orderFreezeTime"
                                    prop="orderFreezeTime"
                                    label="订单冻结时间（分钟）"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="0"
                                        v-model.number="formModel.orderFreezeTime"
                                    />
                                    为0不限制
                                </el-form-item>
                                <el-form-item
                                    key="orderAllowRefundTime"
                                    prop="orderAllowRefundTime"
                                    label="订单付款后允许售后时间（天）"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="0"
                                        v-model.number="formModel.orderAllowRefundTime"
                                    />
                                    为0不限制
                                </el-form-item>
                                <el-form-item
                                    key="directMailOrderAllowRefundTime"
                                    prop="directMailOrderAllowRefundTime"
                                    label="直邮订单付款后允许售后时间（天）"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="0"
                                        v-model.number="formModel.directMailOrderAllowRefundTime"
                                    />
                                    为0不限制
                                </el-form-item>
                                <el-form-item
                                    prop="isAutoStockHandleOrder"
                                    label="是否自动转仓库处理"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isAutoStockHandleOrder"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isUseCommWechatAuth"
                                    label="是否使用微信通用授权回调"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isUseCommWechatAuth"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isUseCommPaySite"
                                    label="是否使用通用付款地址"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isUseCommPaySite"
                                    />
                                </el-form-item>
                                <!--                                <el-form-item
                                    prop="sendConsignor"
                                    label="发件人"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.sendConsignor"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="sendTel"
                                    label="发件人电话"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.sendTel"
                                        auto-complete="off"
                                    />
                                </el-form-item>-->
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>门店设置</span>
                            </div>
                            <div class="item">
                                <!--                    <el-form-item
            key="shopStoreType"
            prop="shopStoreType"
            label="门店类型"
            label-width="13em"
            >
            <dictionaries-picker
            type="shopStoreType"
            v-model="formModel.shopStoreType"
            />
            </el-form-item>
            <el-form-item
            key="storeOpenMode"
            prop="storeOpenMode"
            label="门店开通模式"
            label-width="13em"
            v-if="formModel.shopStoreType != 99"
            >
            <dictionaries-picker
            type="storeOpenMode"
            v-model="formModel.storeOpenMode"
            />
            </el-form-item>-->
                                <!--
            <el-form-item
            key="storePaymentType"
            prop="storePaymentType"
            label="门店付款类型"
            label-width="13em"
            >
            <checkbox-group-andOr
            :data="[
            {id:2,name:'微信支付'},
            {id:4,name:'银联支付'},
            {id:8,name:'通联支付'},
            {id:16,name:'alphapay'},
            {id:32,name:'支付宝支付'},
            {id:64,name:'Stripe'},
            {id:128,name:'中投科信'},
            {id:256,name:'hantePay'},
            {id:512,name:'citconPay'},
            {id:2048,name:'现金支付'},
            {id:4096,name:'小程序支付'},
            ]"
            v-model="formModel.storePaymentType"
            />
            </el-form-item>-->
                                <el-form-item
                                    prop="pickupGoodsSendMode"
                                    label="自取发货方式"
                                    label-width="13em"
                                    v-if="(formModel.shipMethod & 2) !== 0"
                                >
                                    <el-checkbox-group v-model="formModel.pickupGoodsSendMode">
                                        <el-checkbox label="6">
                                            社区配送
                                        </el-checkbox>
                                        <el-checkbox label="1">
                                            国内现货
                                        </el-checkbox>
                                        <el-checkbox label="2">
                                            跨境直邮
                                        </el-checkbox>
                                        <el-checkbox label="3">
                                            BC直邮
                                        </el-checkbox>
                                        <el-checkbox label="4">
                                            保税区发货
                                        </el-checkbox>
                                        <el-checkbox label="5">
                                            一般贸易
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item
                                    prop="isStoreShowShopGoods"
                                    label="门店是否显示店铺产品"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isStoreShowShopGoods"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="storeIncomeRate"
                                    prop="storeIncomeRate"
                                    label="门店分佣比例"
                                    label-width="13em"
                                >
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :precision="2"
                                        v-model.number="formModel.storeIncomeRate"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>客服设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    key="wxQrCode"
                                    prop="wxQrCode"
                                    label="公众号二维码"
                                    label-width="13em"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.wxQrCode"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="customerServiceImg"
                                    label="客服图标"
                                    label-width="13em"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.customerServiceImg"
                                        tips="只能上传jpg/png/gif文件"
                                        accept="image/jpeg,image/gif,image/png"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="meiQiaEntId"
                                    label="美洽企业ID"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.meiQiaEntId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="meiQiaCustomerService"
                                    label="美洽客服配置"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.meiQiaCustomerService"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isShowEnterpriseWeChat"
                                    label="是否显示企业微信"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isShowEnterpriseWeChat"
                                    />
                                </el-form-item>
                                <el-form-item
                                    key="enterpriseWeChatImage"
                                    prop="enterpriseWeChatImage"
                                    label="企业微信图片"
                                    label-width="13em"
                                    v-if="formModel.isShowEnterpriseWeChat"
                                >
                                    <upload
                                        validate-md5
                                        action="/rs/attachment/uploadFileLibrary"
                                        :limit="1"
                                        v-model="formModel.enterpriseWeChatImage"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>打印设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="printerType"
                                    label="打印机类型"
                                    label-width="13em"
                                >
                                    <dictionaries-picker
                                        type="printerType"
                                        v-model="formModel.printerType"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="waybillTemplate"
                                    label="配送模板"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        rows="6"
                                        v-model="formModel.waybillTemplate"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    v-if="+formModel.printerType === 1"
                                    label-width="13em"
                                >
                                    <el-button
                                        type="primary"
                                        size="small"
                                        @click="onEditWaybillTemplate"
                                    >
                                        编辑模板
                                    </el-button>
                                    <el-button
                                        size="small"
                                        @click="onPreviewWaybillTemplate"
                                    >
                                        预览模板
                                    </el-button>
                                </el-form-item>
                                <el-form-item
                                    prop="storeTemplate"
                                    label="自取模板"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        rows="6"
                                        v-model="formModel.storeTemplate"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    v-if="+formModel.printerType === 1"
                                    label-width="13em"
                                >
                                    <el-button
                                        type="primary"
                                        size="small"
                                        @click="onEditStoreTemplate"
                                    >
                                        编辑模板
                                    </el-button>
                                    <el-button
                                        size="small"
                                        @click="onPreviewStoreTemplate"
                                    >
                                        预览模板
                                    </el-button>
                                </el-form-item>
                                <el-form-item
                                    prop="orderCancelTemplate"
                                    label="订单取消模板"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        rows="6"
                                        v-model="formModel.orderCancelTemplate"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>第三方平台设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="publicToken"
                                    label="对外公共接口TOKEN"
                                    label-width="13em"
                                >
                                    <el-input
                                        v-model="formModel.publicToken"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isPushOrderToGateway"
                                    label="订单是否推送网关"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isPushOrderToGateway"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayAppKey"
                                    label="gatewayAppKey"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayAppKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayAppSecret"
                                    label="gatewayAppSecret"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayAppSecret"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayPlatformName"
                                    label="gatewayPlatformName"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayPlatformName"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayPlatformCode"
                                    label="gatewayPlatformCode"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayPlatformCode"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayDistributorName"
                                    label="gatewayDistributorName"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayDistributorName"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayEbpCode"
                                    label="gatewayEbpCode"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayEbpCode"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayRecpAccount"
                                    label="gatewayRecpAccount"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayRecpAccount"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayRecpCode"
                                    label="gatewayRecpCode"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayRecpCode"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="gatewayRecpName"
                                    label="gatewayRecpName"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToGateway"
                                >
                                    <el-input
                                        v-model="formModel.gatewayRecpName"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <!--

            <el-form-item
            prop="isPushOrderErp"
            label="订单是否推送erp"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isPushOrderErp"
            />
            </el-form-item>
            <el-form-item
            prop="erpAppKey"
            label="erpAppKey"
            label-width="13em"
            v-if="formModel.isPushOrderErp"
            >
            <el-input
            v-model="formModel.erpAppKey"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="erpAppSecret"
            label="erpAppSecret"
            label-width="13em"
            v-if="formModel.isPushOrderErp"
            >
            <el-input
            v-model="formModel.erpAppSecret"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="qskdAppKey"
            label="签收快递AppKey"
            label-width="13em"
            >
            <el-input
            v-model="formModel.qskdAppKey"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="qskdAppSecret"
            label="签收快递AppSecret"
            label-width="13em"
            >
            <el-input
            v-model="formModel.qskdAppSecret"
            auto-complete="off"
            />
            </el-form-item>-->
                                <!--                    <el-form-item
            prop="isShowRMBAmount"
            label="是否显示人民币"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isShowRMBAmount"
            />
            </el-form-item>
            <el-form-item
            prop="RMBAmountRate"
            label="人民币汇率"
            label-width="13em"
            v-if="formModel.isShowRMBAmount"
            >
            <el-input-number
            controls-position="right"
            :min="0"
            :precision="4"
            v-model.number="formModel.RMBAmountRate"
            />
            </el-form-item>-->
                                <!--
            <el-form-item
            prop="isStoreEditSendInfo"
            label="门店是否维护发件人信息"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isStoreEditSendInfo"
            />
            </el-form-item>
            <el-form-item
            prop="isOrderEditSendInfo"
            label="下单修改发件人信息"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isOrderEditSendInfo"
            />
            </el-form-item>-->
                                <!--

            <el-form-item
            prop="marketCodeContacts"
            label="一物一码联系人"
            label-width="13em"
            >
            <el-input
            v-model="formModel.marketCodeContacts"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="marketCodeCouponId"
            label="一物一码优惠券ID"
            label-width="13em"
            >
            <el-input
            v-model="formModel.marketCodeCouponId"
            auto-complete="off"
            />
            </el-form-item>
            <el-form-item
            prop="marketCodeWarnNum"
            label="一物一码最大查询次数"
            label-width="13em"
            >
            <el-input-number
            controls-position="right"
            :min="1"
            :precision="0"
            v-model.number="formModel.marketCodeWarnNum"
            />
            </el-form-item>
            <el-form-item
            prop="isGiftCardReturnPurse"
            label="礼品卡是否返还零钱"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isGiftCardReturnPurse"
            />
            </el-form-item>
            <el-form-item
            prop="isRegisterIHealth"
            label="是否注册iHealth"
            label-width="13em"
            >
            <el-switch
            v-model="formModel.isRegisterIHealth"
            />
            </el-form-item>-->
                                <el-form-item
                                    prop="iHealthApiKey"
                                    label="iHealthApiKey"
                                    label-width="13em"
                                    v-if="formModel.isRegisterIHealth"
                                >
                                    <el-input
                                        v-model="formModel.iHealthApiKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="iHealthApiLock"
                                    label="iHealthApiLock"
                                    label-width="13em"
                                    v-if="formModel.isRegisterIHealth"
                                >
                                    <el-input
                                        v-model="formModel.iHealthApiLock"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncWeimobcloud"
                                    label="是否同步微盟云"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncWeimobcloud"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="weimobcloudShopId"
                                    label="微盟云ShopId"
                                    label-width="13em"
                                    v-if="formModel.isSyncWeimobcloud"
                                >
                                    <el-input
                                        v-model="formModel.weimobcloudShopId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="weimobcloudClientId"
                                    label="微盟云ClientId"
                                    label-width="13em"
                                    v-if="formModel.isSyncWeimobcloud"
                                >
                                    <el-input
                                        v-model="formModel.weimobcloudClientId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="weimobcloudClientSecret"
                                    label="微盟云ClientSecret"
                                    label-width="13em"
                                    v-if="formModel.isSyncWeimobcloud"
                                >
                                    <el-input
                                        v-model="formModel.weimobcloudClientSecret"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncWeimobcloudStock"
                                    label="是否自动同步微盟云库存"
                                    label-width="13em"
                                    v-if="formModel.isSyncWeimobcloud"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncWeimobcloudStock"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncSifeiErp"
                                    label="是否同步思飞Erp"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncSifeiErp"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="sifeiAppId"
                                    label="思飞AppId"
                                    label-width="13em"
                                    v-if="formModel.isSyncSifeiErp"
                                >
                                    <el-input
                                        v-model="formModel.sifeiAppId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="sifeiAppKey"
                                    label="思飞AppKey"
                                    label-width="13em"
                                    v-if="formModel.isSyncSifeiErp"
                                >
                                    <el-input
                                        v-model="formModel.sifeiAppKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncPospal"
                                    label="是否同步银豹"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncPospal"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncPospalStock"
                                    label="是否同步银豹库存"
                                    label-width="13em"
                                    v-if="formModel.isSyncPospal"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncPospalStock"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="pospalAreaId"
                                    label="银豹区域ID"
                                    label-width="13em"
                                    v-if="formModel.isSyncPospal"
                                >
                                    <el-input
                                        v-model="formModel.pospalAreaId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="pospalAppId"
                                    label="银豹AppId"
                                    label-width="13em"
                                    v-if="formModel.isSyncPospal"
                                >
                                    <el-input
                                        v-model="formModel.pospalAppId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="pospalAppKey"
                                    label="银豹AppKey"
                                    label-width="13em"
                                    v-if="formModel.isSyncPospal"
                                >
                                    <el-input
                                        v-model="formModel.pospalAppKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isPushInventory"
                                    label="是否推送进销存系统"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isPushInventory"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncInventoryGoods"
                                    label="是否同步进销存商品"
                                    label-width="13em"
                                    v-if="formModel.isPushInventory"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncInventoryGoods"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="inventoryAppKey"
                                    label="进销存系统AppKey"
                                    label-width="13em"
                                    v-if="formModel.isPushInventory"
                                >
                                    <el-input
                                        v-model="formModel.inventoryAppKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="inventoryAppSecret"
                                    label="进销存系统AppSecret"
                                    label-width="13em"
                                    v-if="formModel.isPushInventory"
                                >
                                    <el-input
                                        v-model="formModel.inventoryAppSecret"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isSyncKuaidi100TrackingInfo"
                                    label="是否同步快递100物流信息"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isSyncKuaidi100TrackingInfo"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="kuaidi100Customer"
                                    label="快递100Customer"
                                    label-width="13em"
                                    v-if="formModel.isSyncKuaidi100TrackingInfo"
                                >
                                    <el-input
                                        v-model="formModel.kuaidi100Customer"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="kuaidi100ConstAppKey"
                                    label="快递100ConstAppKey"
                                    label-width="13em"
                                    v-if="formModel.isSyncKuaidi100TrackingInfo"
                                >
                                    <el-input
                                        v-model="formModel.kuaidi100ConstAppKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="isPushOrderToYBG"
                                    label="订单是否推送洋包裹"
                                    label-width="13em"
                                >
                                    <el-switch
                                        v-model="formModel.isPushOrderToYBG"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="ybgCustomerId"
                                    label="洋包裹CustomerId"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToYBG"
                                >
                                    <el-input
                                        v-model="formModel.ybgCustomerId"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="ybgMerKey"
                                    label="洋包裹MerKey"
                                    label-width="13em"
                                    v-if="formModel.isPushOrderToYBG"
                                >
                                    <el-input
                                        v-model="formModel.ybgMerKey"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>提现设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="weixinWithdrawConfig"
                                    label="微信提现配置"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.weixinWithdrawConfig"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-card
                            size="small"
                            shadow="never"
                            class="ma-t"
                        >
                            <div
                                slot="header"
                                class="clearfix"
                            >
                                <span>广告设置</span>
                            </div>
                            <div class="item">
                                <el-form-item
                                    prop="shopAdPageType"
                                    label="店铺广告位管理"
                                    label-width="13em"
                                >
                                    <el-checkbox-group v-model="formModel.shopAdPageType">
                                        <el-checkbox
                                            v-for="item in adPageTypeList"
                                            :key="item.id + ''"
                                            :label="item.id + ''"
                                        >
                                            {{ item.name }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item
                                    prop="storeAdPageType"
                                    label="门店广告位管理"
                                    label-width="13em"
                                >
                                    <el-checkbox-group v-model="formModel.storeAdPageType">
                                        <el-checkbox
                                            v-for="item in adPageTypeList"
                                            :key="item.id + ''"
                                            :label="item.id + ''"
                                        >
                                            {{ item.name }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item
                                    prop="distributorPosterConfig"
                                    label="分销商海报配置"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.distributorPosterConfig"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                                <el-form-item
                                    prop="storeOfflinePosterConfig"
                                    label="门店线下收款海报配置"
                                    label-width="13em"
                                >
                                    <el-input
                                        type="textarea"
                                        v-model="formModel.storeOfflinePosterConfig"
                                        auto-complete="off"
                                    />
                                </el-form-item>
                            </div>
                        </el-card>
                        <el-form-item
                            label-width="13em"
                        >
                            <el-button
                                type="primary"
                                size="small"
                                @click="onConfirm"
                            >
                                保 存
                            </el-button>
                            <el-button
                                size="small"
                                @click="$router.back()"
                            >
                                返 回
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </template>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';

export default {
    name: 'ShopEdit',
    mixins: [pagesMixin],
    data() {
        return {
            // 表单数据
            formModel: {
                id: '',
                orgId: '',
                shopName: '',
                shopSn: '',
                shopLogo: [],
                shopShareLogo: [],
                principalName: '',
                principalPosition: '',
                principalMobile: '',
                principalEmail: '',
                principalQq: '',
                shopRegionId: '',
                shopAddress: '',
                shopDesc: '',
                freightMode: '3',
                isAllowMoreLevel: false,
                shopDomain: '',
                shopLevelId: '',
                shopStatus: '',
                isOpenMemberRegister: true,
                isCheckMobileFormat: true,
                isCheckMobileCode: true,
                memberRegisterMode: '1',
                memberAccountSign: '',
                mapPlaceKey: '',
                publicApikey: '',
                publicSecret: '',
                publicToken: '',
                remarks: '',
                distributionIncomeMode: '',
                distributorRegisterMode: 99,
                isMustInvitationCode: false,
                distributionLevel: '',
                sellGoodsType: '1',
                shipMethod: '1',
                paymentMode: '1',
                onlinePaymentType: '2',
                prepaidPaymentType: '',
                storePaymentType: '',
                orderNoticeMode: '',
                orderNoticeMobile: '',
                orderNoticeWebchat: '',
                isAllowOrder: '',
                orderAmountLimit: '',
                orderFreezeTime: '',
                orderAllowRefundTime: '',
                directMailOrderAllowRefundTime: '',
                isShowNotice: false,
                shopNoticeImage: [],
                shopNoticeLink: '',
                loadingImg: [],
                miniAppsImg: [],
                customerServiceImg: [],
                printerType: '1',
                waybillTemplate: '',
                storeTemplate: '',
                orderCancelTemplate: '',
                currencySymbol: '￥',
                currencyCode: 'CNY',
                themeColorMain: '',
                themeColorSecond: '',
                isQuickBuyerAddress: 0,
                moduleConfigCart: 0,
                isGoodsMultiStyle: false,
                shopStoreType: '99',
                meiQiaEntId: '',
                meiQiaCustomerService: '',
                isPushOrderErp: false,
                erpAppKey: '',
                erpAppSecret: '',
                isPushOrderToGateway: false,
                gatewayAppKey: '',
                gatewayAppSecret: '',
                gatewayPlatformName: '',
                gatewayPlatformCode: '',
                gatewayDistributorName: '',
                gatewayEbpCode: '',
                gatewayRecpAccount: '',
                gatewayRecpCode: '',
                gatewayRecpName: '',
                isShowRMBAmount: false,
                RMBAmountRate: '',
                sendConsignor: '',
                sendTel: '',
                isStoreEditSendInfo: false,
                storeOpenMode: '',
                qskdAppKey: '',
                qskdAppSecret: '',
                amountFormat: '+0.00',
                prepaidPaymentMode: '1',
                distributorQrcodeExpire: '7',
                isDistributorQrcodeUnique: false,
                isOrderEditSendInfo: false,
                minWithdrawAmount: '',
                withdrawPoundageRate: '',
                withdrawAutoPassTime: '',
                withdrawDesc: '',
                goodsSendMode: [1, 4],
                threeFactorCheck: [],
                pickupGoodsSendMode: [],
                goodsConfig: '',
                buyerConfig: '',
                marketCodeContacts: '',
                marketCodeCouponId: '',
                marketCodeWarnNum: '',
                isGiftCardReturnPurse: false,
                isRegisterIHealth: false,
                iHealthApiKey: '',
                iHealthApiLock: '',
                defaultShareIncomeRate: '',
                storeIncomeRate: '',
                isUseCommWechatAuth: false,
                isUseCommPaySite: false,
                enableBehavior: false,
                wxQrCode: [],
                isSyncWeimobcloud: false,
                isSyncWeimobcloudStock: false,
                weimobcloudShopId: '',
                weimobcloudClientId: '',
                weimobcloudClientSecret: '',
                isSyncSifeiErp: false,
                sifeiAppId: '',
                sifeiAppKey: '',
                isSyncPospal: false,
                isSyncPospalStock: false,
                pospalAreaId: '',
                pospalAppId: '',
                pospalAppKey: '',
                eachLevelIncomeDayLimit: 0,
                goodsCatStyle: 1,
                isShowEnterpriseWeChat: false,
                enterpriseWeChatImage: [],
                distributorPosterConfig: '',
                storeOfflinePosterConfig: '',

                isPushInventory: false,
                isSyncInventoryGoods: false,
                inventoryAppKey: '',
                inventoryAppSecret: '',

                isStoreShowShopGoods: true,

                weixinWithdrawConfig: '',
                balanceAlias: '',
                isAutoStockHandleOrder: false,

                isSyncKuaidi100TrackingInfo: false,
                kuaidi100Customer: '',
                kuaidi100ConstAppKey: '',

                autoSettlementDay: -1,
                shopAdPageType: [],
                storeAdPageType: [],

                goodsSendMode2OrderAmountLimit: 800,
                goodsSendMode4OrderAmountLimit: 5000,

                isPushOrderToYBG: false,
                ybgCustomerId: '',
                ybgMerKey: '',
            },
            // 表单校验规则
            formRules: {
                orgId: {
                    required: true,
                    message: '请选择组织机构',
                    trigger: 'blur',
                },
                shopName: {
                    required: true,
                    message: '请输入店铺名称',
                    trigger: 'blur',
                },
                shopLogo: {
                    type: 'array',
                    required: true,
                    message: '请上传图片',
                },
                miniAppsImg: {
                    type: 'array',
                    required: true,
                    message: '请上传小程序图片',
                },
                customerServiceImg: {
                    type: 'array',
                    required: true,
                    message: '请上传客服图片',
                },
                freightMode: {
                    required: true,
                    message: '请选择运费模式',
                    trigger: 'blur',
                },
                isAllowMoreLevel: {
                    required: true,
                    message: '请选择是否开启二级节点',
                    trigger: 'blur',
                },
                sellGoodsType: [
                    {
                        required: true,
                        message: '请选择售卖商品类型',
                    },
                    {
                        type: 'integer',
                        min: 1,
                        message: '请选择售卖商品类型',
                    },
                ],
                shopDomain: {
                    required: true,
                    message: '请输入店铺域名',
                },
                shopLevelId: {
                    required: true,
                    message: '请选择店铺等级',
                },
                shopStatus: {
                    required: true,
                    message: '请选择商户状态',
                },
                isMustInvitationCode: {
                    required: true,
                    message: '请选择推荐码是否必填',
                },
                distributorRegisterMode: {
                    required: true,
                    message: '请选择分销注册模式',
                },
                memberAccountSign: {
                    required: true,
                    message: '请输入会员账号标识',
                },
                distributionLevel: {
                    required: true,
                    message: '请选择提成层级',
                },
                shipMethod: [
                    {
                        required: true,
                        message: '请选择配送方式',
                    },
                    {
                        type: 'integer',
                        min: 1,
                        message: '请选择配送方式',
                    },
                ],
                paymentMode: [
                    {
                        required: true,
                        message: '请选择付款模式',
                    },
                    {
                        type: 'integer',
                        min: 1,
                        message: '请选择付款模式',
                    },
                ],
                onlinePaymentType: [
                    {
                        required: true,
                        message: '请选择线上付款模式',
                    },
                    {
                        type: 'integer',
                        min: 1,
                        message: '请选择线上付款模式',
                    },
                ],
                shopNoticeImage: {
                    type: 'array',
                    required: true,
                    message: '请上传公告图片',
                },
                goodsSendMode: {
                    type: 'array',
                    required: true,
                    message: '请选择送货方式',
                },
                currencySymbol: {
                    required: true,
                    message: '请输入币种符号',
                    trigger: 'blur',
                },
                currencyCode: {
                    required: true,
                    message: '请输入币种代码',
                    trigger: 'blur',
                },
                themeColorMain: {
                    required: true,
                    message: '请选择皮肤主颜色',
                    trigger: 'blur',
                },
                themeColorSecond: {
                    required: true,
                    message: '请选择皮肤副颜色',
                    trigger: 'blur',
                },
                isQuickBuyerAddress: {
                    required: true,
                    message: '请选择',
                    trigger: 'blur',
                },
                moduleConfigCart: {
                    required: true,
                    message: '请选择',
                    trigger: 'blur',
                },
                isGoodsMultiStyle: {
                    required: true,
                    message: '请选择',
                    trigger: 'blur',
                },
                storeOpenMode: {
                    required: true,
                    message: '请选择',
                },
                shopStoreType: {
                    required: true,
                    message: '请选择',
                },
                isDistributorQrcodeUnique: {
                    required: true,
                    message: '请选择',
                },
                isOrderEditSendInfo: {
                    required: true,
                    message: '请选择',
                },
                distributorQrcodeExpire: {
                    required: true,
                    message: '请输入分销商二维码有效期',
                },
                eachLevelIncomeDayLimit: {
                    required: true,
                    message: '请输入层级提成注册限制时间',
                },
                goodsCatStyle: {
                    required: true,
                    message: '请选择商品分类样式',
                },
            },
            selectApi: this.$api.Rs.Region,
            shopLevelList: [],
            // 组织机构列表
            orgList: [],
            adPageTypeList: [],
        };
    },
    methods: {
        onConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                if (this.shareincome && this.formModel.defaultShareIncomeRate + this.formModel.storeIncomeRate > 100) {
                    this.$message({
                        message: '默认分享提成比例+门店级分佣比例不能大于100%',
                        type: 'error',
                    });
                    return;
                }
                this.$api.Sp.Shop.save({
                    ...this.formModel,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.$router.back();
                });
            });
        },
        getShopLevelList() {
            this.$api.Sp.ShopLevel.select().then(res => {
                this.shopLevelList = res.data.data;
            });
        },
        initOrgList() {
            this.$api.Rs.Org.select().then(json => {
                const res = json.data.data;
                this.orgList = res;
            });
        },
        initShop() {
            this.$api.Sp.Shop.getDetail({ id: this.formModel.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(this.formModel, res);
            });
        },
        onEditWaybillTemplate() {
            const template = this.formModel.waybillTemplate;
            const lodop = `${template}LODOP.NewPage();LODOP.SET_PRINT_MODE('PRINT_SETUP_PROGRAM',true);`;
            this.$lodop.init(lodop).then(({ LODOP, CLODOP }) => {
                CLODOP.On_Return = (taskId, value) => {
                    this.formModel.waybillTemplate = value;
                };
                LODOP.PRINT_DESIGN();
            });
        },
        onPreviewWaybillTemplate() {
            const template = this.formModel.waybillTemplate;
            const lodop = `${template}`;
            this.$lodop.init(lodop).then(({ LODOP }) => {
                LODOP.PREVIEW();
            });
        },
        onEditStoreTemplate() {
            const template = this.formModel.storeTemplate;
            const lodop = `${template}LODOP.NewPage();LODOP.SET_PRINT_MODE('PRINT_SETUP_PROGRAM',true);`;
            this.$lodop.init(lodop).then(({ LODOP, CLODOP }) => {
                CLODOP.On_Return = (taskId, value) => {
                    this.formModel.storeTemplate = value;
                };
                LODOP.PRINT_DESIGN();
            });
        },
        onPreviewStoreTemplate() {
            const template = this.formModel.storeTemplate;
            const lodop = `${template}`;
            this.$lodop.init(lodop).then(({ LODOP }) => {
                LODOP.PREVIEW();
            });
        },
        initAdPageType() {
            this.$api.Rs.Dic.entrys({ dicCode: 'adPageType' }).then(json => {
                this.adPageTypeList = json.data.data;
            });
        },
    },
    computed: {
        shareincome() {
            return (this.formModel.distributionIncomeMode & 1) !== 0;
        },
        eachlevelincome() {
            return (this.formModel.distributionIncomeMode & 4) !== 0;
        },
        onlinePayment() {
            return (this.formModel.paymentMode & 1) !== 0;
        },
        onlinePaymentBalance() {
            return (this.formModel.prepaidPaymentMode & 1) !== 0;
        },
        orderNoticeMobile() {
            return (this.formModel.orderNoticeMode & 1) !== 0;
        },
    },
    created() {
        this.getShopLevelList();
        this.initOrgList();
        this.initAdPageType();
        this.formModel.id = this.$route.params.id;
        if (this.formModel.id) {
            this.initShop();
        }
    },
};
</script>

<style lang="scss">
</style>
